/**
 * User-facing validation messages for the single-order "Mark as Completed"
 * button's disabling conditions (see `isSubmitDisabled` in
 * `pages/singleOrderLayout/singleOrderLayout.tsx`).
 *
 * Each key maps 1:1 to a condition that can disable the button, so the same
 * message can be reused in tooltips, banners, toasts, or help text anywhere
 * in the app.
 *
 * @module markCompleteValidationMessages
 */
export enum MarkCompleteValidationMessages {
  // Review documents required, but none exist yet
  REVIEW_DOCUMENTS_REQUIRED = "Order review required",

  // Any J-code has auth_status "not_available"
  JCODE_NOT_AVAILABLE = "Auth-on-file J-code(s) with status 'Not Available'",

  // Any J-code is missing an uploaded auth letter, or the letter's
  // auth_letter_review_status is empty
  AUTH_LETTER_REVIEW_PENDING = "Auth letter upload or review required",

  AUTH_LETTER_REVIEW_CHECKING = "Checking fax letter review status",
  AUTH_LETTER_REVIEW_UNAVAILABLE = "Unable to verify fax letter review; refresh to retry",

  // CPT-table values (start/end date, auth #, total visits) differ from the
  // auth-letter values
  AUTH_LETTER_FIELD_MISMATCH = "CPT values do not match the auth letter",

  // Primary diagnosis has not been validated
  PRIMARY_DIAGNOSIS_NOT_VALIDATED = "Primary diagnosis validation required",

  // Facility requires a site NPI type and the order's npi_type is missing
  SITE_NPI_REQUIRED = "Site NPI type required",

  // CPT table has unsaved changes
  CPT_UNSAVED_CHANGES = "Unsaved CPT changes",

  // FC Hold orgs (OCSRI): the work start (recorded by the first Trigger RPA)
  // is required before a final determination can be completed
  FC_HOLD_VALUE_REQUIRED = "FC Hold work start required — run Trigger RPA once to record the RISA Working stamp, then Mark as Completed",
}
